import { registerPopoverStore } from '@app/Common/Components/Popover/front';

import './front.scss';
import { viewNamespace } from './constants';

registerPopoverStore(viewNamespace);
